import { createAction, emptyProps, props } from '@ngrx/store';

import { BbaCancellationStatusFilter, BbaCropField } from '../models/bba-cancellation.model';

export const loadBBACropFieldsRequest = createAction('[BBA Cancellation] Load BBA Crop Fields request', emptyProps);

export const loadBBACropFieldsSuccess = createAction(
  '[BBA Cancellation] Load BBA Crop Fields success',
  props<{ cropFields: BbaCropField[]; totalCropFieldsCount: number }>(),
);

export const loadBBACropFieldsFailure = createAction('[BBA Cancellation] Load BBA Crop Fields failure', props<{ translationKey: string }>());

export const changeSelectedCropYear = createAction('[BBA Cancellation] Change Crop Year', props<{ cropYear: number }>());

export const changeStatusFilter = createAction('[BBA Cancellation] Change Status Filter', props<{ statusFilter: BbaCancellationStatusFilter }>());

export const changeSearchFilter = createAction('[BBA Cancellation] Change Search Term', props<{ searchTerm: string }>());

export const changeCustomerFilter = createAction('[BBA Cancellation] Change Customer Search Term', props<{ searchTerm: string }>());

export const changeCropFieldFilter = createAction('[BBA Cancellation] Change Crop Field Search Term', props<{ searchTerm: string }>());

export const resetAllFilters = createAction('[BBA Cancellation] Reset All Filters', emptyProps);

export const changeCropFieldsPage = createAction('[BBA Cancellation] Change Crop Fields Page', props<{ pageNumber: number; pageSize: number }>());

// Cancellation Actions

export const toggleCancellation = createAction(
  '[BBA Cancellation] Toggle Cancellation',
  props<{ adviceId: number; customerId: number; setCancelled: boolean }>(),
);

export const toggleCancellationSuccess = createAction(
  '[BBA Cancellation] Toggle Cancellation Success',
  props<{ adviceId: number; customerId: number; setCancelled: boolean }>(),
);

export const toggleCancellationFailure = createAction(
  '[BBA Cancellation] Toggle Cancellation Failure',
  props<{ translationKey: string; adviceId: number; customerId: number; setCancelled: boolean }>(),
);

// Confirm Cancellations Actions

export const confirmCancellations = createAction('[BBA Cancellation] Confirm Cancellations', emptyProps);

export const confirmCancellationsSuccess = createAction('[BBA Cancellation] Confirm Cancellations Success', emptyProps);

export const confirmCancellationsFailure = createAction('[BBA Cancellation] Confirm Cancellations Failure', props<{ translationKey: string }>());

// Fertilab Actions

export const toggleIsFertilabInformedOfCancellation = createAction(
  '[BBA Cancellation] Toggle Is Fertilab Informed Of Cancellation',
  props<{ isFertilabInformed: boolean; adviceId: number; customerId: number }>(),
);

export const toggleIsFertilabInformedOfCancellationSuccess = createAction(
  '[BBA Cancellation] Toggle Is Fertilab Informed Of Cancellation Success',
  props<{ isFertilabInformed: boolean; adviceId: number; customerId: number }>(),
);

export const toggleIsFertilabInformedOfCancellationFailure = createAction(
  '[BBA Cancellation] Toggle Is Fertilab Informed Of Cancellation Failure',
  props<{ translationKey: string; isFertilabInformed: boolean; adviceId: number; customerId: number }>(),
);

// Administration Actions

export const toggleIsAdministrationInformedOfCancellation = createAction(
  '[BBA Cancellation] Toggle Is Administration Informed Of Cancellation',
  props<{ isAdministrationInformed: boolean; adviceId: number; customerId: number }>(),
);

export const toggleIsAdministrationInformedOfCancellationSuccess = createAction(
  '[BBA Cancellation] Toggle Is Administration Informed Of Cancellation Success',
  props<{ isAdministrationInformed: boolean; adviceId: number; customerId: number }>(),
);

export const toggleIsAdministrationInformedOfCancellationFailure = createAction(
  '[BBA Cancellation] Toggle Is Administration Informed Of Cancellation Failure',
  props<{ translationKey: string; isAdministrationInformed: boolean; adviceId: number; customerId: number }>(),
);
